/**
 * `wpp::banner`
 *
 * Dismissal is deliberately not remembered. A banner says something is true of
 * the application right now — maintenance, a source system being down — and a
 * dismissal that outlived the condition would hide a message that still applies.
 * An application that wants a banner dismissed for good should stop rendering it.
 */
export default () => ({
    shown: true,

    dismiss() {
        this.shown = false;
    },
});
